import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAddEdgeIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 16,
			cy: 16,
			r: 16,
			fill: "#C7D2FE"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 16,
			cy: 16,
			r: 15,
			fill: "#6A63F1"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 15.8041,
			y1: 10.277,
			x2: 15.8041,
			y2: 21.7987,
			stroke: "white",
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 10.2389,
			y1: 16.1956,
			x2: 21.7606,
			y2: 16.1956,
			stroke: "white",
			strokeLinecap: "round"
		})
	]
});
export default SvgAddEdgeIcon;
